import { render, staticRenderFns } from "./user-landing.vue?vue&type=template&id=1166b914&scoped=true"
import script from "./user-landing.vue?vue&type=script&lang=js"
export * from "./user-landing.vue?vue&type=script&lang=js"
import style0 from "./user-landing.vue?vue&type=style&index=0&id=1166b914&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1166b914",
  null
  
)

export default component.exports